export default "__VITE_ASSET__4ec534e6__"